/**
 * Account status of user
 */
export enum UserStatus {
  Pending = "pending",
  Accepted = "accepted",
  Denied = "denied",
}
